import styles from './css/Horse.module.css';
import NavBar from '../../Components/NavBar/NavBar';
import PageHeader from '../../Components/PageHeader/PageHeader';
import FullWidthCTA from '../../Components/FullWidthCTA/FullWidthCTA';
import Footer from '../../Components/Footer/Footer';
import { useNavigate, useParams } from 'react-router-dom';
import useFetch from '../../Hooks/useFetch';
import { useMemo, useState } from 'react';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import magGlass from './images/mag_glass.png';
import FamilyTree from '../../Components/FamilyTree/FamilyTree';
import LightBox from '../../Components/LightBox/LightBox';
import fallbackHorseImage from './images/horse_black_running_animal_silhouette.webp';

const Horse = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  // Fetch the horse data and store it in the currentHorse state
  const { data: currentHorse } = useFetch(`horses/${id}?populate=*`);

  const [currentImage, setCurrentImage] = useState(0);
  const [openLightBox, setOpenLightBox] = useState(false);

  // useMemo to store the image URLs
  const imageUrls = useMemo(() => {
    if (currentHorse?.data.images) {
      return currentHorse?.data.images.map((image) => process.env.REACT_APP_API_URI + image.url);
    }
    return [];
  }, [currentHorse]);

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      <NavBar />
      {currentHorse && (
        <PageHeader
          title={`${currentHorse?.data.section} - ${currentHorse?.data.gender} - ${currentHorse?.data.name}`}
        />
      )}
      {currentHorse && (
        <>
          <section className={`${styles.horseDetails} container`}>
            <button className={styles.backLink} onClick={goBack}>
              <span className={styles.backArrow}>&lt;</span> Back
            </button>
            <div className={styles.horseInfo}>
              {!!currentHorse.data.images ? (
                <div className={styles.imageContainer}>
                  <img
                    loading='lazy'
                    className={styles.mainImage}
                    src={imageUrls[currentImage]}
                    alt={currentHorse.data.images[currentImage].alternativeText}
                  />
                  <button
                    type='button'
                    className={styles.magGlassButton}
                    onClick={() => setOpenLightBox(true)}>
                    <img loading='lazy' src={magGlass} alt='magnifying glass icon' />
                  </button>
                  <div className={styles.imageSelector}>
                    {currentHorse.data.images.map((image, index) => (
                      <div className={styles.selectorThumbnail} key={image.id}>
                        <img
                          loading='lazy'
                          src={process.env.REACT_APP_API_URI + image.formats.thumbnail.url}
                          alt={image.alternativeText}
                          onClick={() => {
                            setCurrentImage(index);
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className={styles.imageContainer}>
                  <img
                    loading='lazy'
                    className={styles.mainImage}
                    src={fallbackHorseImage}
                    alt='White horse silhouette on a dark background'
                  />
                </div>
              )}
              <div className={styles.horseTextContent}>
                <h2 className={styles.horseName}>{currentHorse?.data.name}</h2>
                {/* Display only the year the horse was born - date format yyyy-mm-dd */}
                {currentHorse?.data.birth_date && (
                  <p className={styles.horseBirthYear}>Born {currentHorse.data.birth_date.split('-')[0]}</p>
                )}
                <p className={styles.horseSubHeading}>{currentHorse?.data.sub_heading}</p>

                <p className={styles.horseSire}>
                  {currentHorse?.data.sire && 'Sire: ' + currentHorse.data.sire}
                </p>

                <p className={styles.horseDam}>{currentHorse?.data.dam && 'Dam: ' + currentHorse.data.dam}</p>

                {currentHorse.data.by_stud && (
                  <p className={styles.horseByStud}>by {currentHorse?.data.by_stud}</p>
                )}
                {currentHorse.data.sold ? (
                  <p className={styles.soldHorse}>Sold</p>
                ) : (
                  currentHorse.data.for_sale && <p className={styles.forSaleHorse}>For Sale</p>
                )}
                <hr />
                <ReactMarkdown className={styles.horseDescription}>
                  {currentHorse?.data.description}
                </ReactMarkdown>
              </div>
            </div>
          </section>
          {currentHorse.data.parents.length > 0 && (
            <FamilyTree horseId={currentHorse.id} horseName={currentHorse?.data.name} />
          )}
        </>
      )}
      {currentHorse?.data.for_sale && currentHorse?.data.sold === false ? (
        <FullWidthCTA textColor={'#ffffff'} backgroundColor={'#5e9653'} horseName={currentHorse.data.name} />
      ) : (
        <FullWidthCTA textColor={'#966a53'} />
      )}

      <Footer />
      {!!currentHorse?.data.images && (
        <LightBox
          images={currentHorse.data.images}
          currentImageIndex={currentImage}
          setCurrentImageIndex={setCurrentImage}
          openLightBox={openLightBox}
          setOpenLightBox={setOpenLightBox}
        />
      )}
    </>
  );
};
export default Horse;
